const prefix = 'DimTaxId';

export enum DimTaxIdField {
  ID = `${prefix}.id`,
  VALUE = `${prefix}.value`,
  VARIANT = `${prefix}.variant`,
  SUPPLIER_ID = `${prefix}.supplierId`,
}
